import React from 'react';
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SellDirectForm } from "@/components/valuation/SellDirectForm";
import { 
  Building2, 
  Zap, 
  ShieldCheck, 
  Clock, 
  ArrowDownCircle 
} from "lucide-react";

export default function SellDirectPage() {
  return (
    <div className="min-h-screen bg-parchment">
      <Navbar />
      <main className="pt-20">
        {/* HERO SECTION */}
        <section className="py-24 bg-ink text-parchment relative overflow-hidden">
          <div className="absolute inset-0 opacity-10 grain-texture pointer-events-none" />
          <div className="container mx-auto px-4 relative z-10 text-center max-w-4xl">
            <span className="text-xs font-black uppercase tracking-[0.5em] text-terracotta mb-6 block">Compra Directa</span>
            <h1 className="text-6xl md:text-8xl font-display font-black uppercase italic leading-none mb-8">
              Vendemos tu propiedad <br /> <span className="text-terracotta text-stroke-parchment">Al Contado</span>
            </h1>
            <p className="text-2xl font-serif italic opacity-60 leading-relaxed max-w-2xl mx-auto mb-12">
              Sin comisiones, sin visitas interminables y con la seguridad de un respaldo institucional. Obtén tu oferta hoy.
            </p>
            <div className="flex justify-center">
              <ArrowDownCircle className="h-12 w-12 text-terracotta animate-bounce" />
            </div>
          </div>
        </section>

        {/* FORM SECTION */}
        <section className="py-20 -mt-10 relative z-20">
          <div className="container mx-auto px-4">
            <SellDirectForm />
          </div>
        </section>

        {/* BENEFITS SECTION */}
        <section className="py-32 bg-white border-y-2 border-ink">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
              <div className="space-y-4">
                <div className="p-4 bg-parchment brutalist-border-sm w-fit">
                  <Zap className="h-8 w-8 text-terracotta" />
                </div>
                <h3 className="text-xl font-display font-black uppercase italic">Rapidez Total</h3>
                <p className="font-serif italic text-muted-foreground leading-relaxed">Oferta formal en 48h y cierre en tiempo récord.</p>
              </div>

              <div className="space-y-4">
                <div className="p-4 bg-parchment brutalist-border-sm w-fit">
                  <ShieldCheck className="h-8 w-8 text-terracotta" />
                </div>
                <h3 className="text-xl font-display font-black uppercase italic">Seguridad Jurídica</h3>
                <p className="font-serif italic text-muted-foreground leading-relaxed">Gestión legal integral respaldada por expertos.</p>
              </div>

              <div className="space-y-4">
                <div className="p-4 bg-parchment brutalist-border-sm w-fit">
                  <Clock className="h-8 w-8 text-terracotta" />
                </div>
                <h3 className="text-xl font-display font-black uppercase italic">Sin Comisiones</h3>
                <p className="font-serif italic text-muted-foreground leading-relaxed">Venta directa sin intermediarios ni costos ocultos.</p>
              </div>

              <div className="space-y-4">
                <div className="p-4 bg-parchment brutalist-border-sm w-fit">
                  <Building2 className="h-8 w-8 text-terracotta" />
                </div>
                <h3 className="text-xl font-display font-black uppercase italic">Todo Tipo de Propiedades</h3>
                <p className="font-serif italic text-muted-foreground leading-relaxed">Casas, departamentos y terrenos en todo Chile.</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
